/* Defy Sports 2026 — Cart JS */
(function () {
  'use strict';

  var drawer  = document.getElementById('defy-cart-drawer');
  var overlay = document.getElementById('defy-cart-overlay');

  // ── Render drawer items from live cart data ──────────────────────────
  function renderCartItems(cart) {
    var body = document.getElementById('defy-cart-items');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="defy-cart-empty">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.3"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
          '<p>Your cart is empty</p>' +
          '<a href="/collections" class="defy-btn defy-btn--primary" data-defy-cart-close>Shop Now</a>' +
        '</div>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imageHtml = '';
      if (item.image) {
        // Shopify CDN: append size param
        var imgSrc = item.image.replace(/(\.[a-z]+)(\?|$)/, '_120x120$1$2');
        imageHtml = '<img src="' + imgSrc + '" alt="' + escapeHtml(item.title) + '" width="80" height="80" loading="lazy">';
      }

      var variantHtml = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantHtml = '<p class="defy-cart-item__variant">' + escapeHtml(item.variant_title) + '</p>';
      }

      var propertiesHtml = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (key) {
          var val = item.properties[key];
          if (val && val !== '') {
            propertiesHtml += '<p class="defy-cart-item__property">' + escapeHtml(key) + ': ' + escapeHtml(String(val)) + '</p>';
          }
        });
      }

      html +=
        '<div class="defy-cart-item" data-item-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="defy-cart-item__image">' + imageHtml + '</a>' +
          '<div class="defy-cart-item__info">' +
            '<a href="' + item.url + '" class="defy-cart-item__title">' + escapeHtml(item.product_title) + '</a>' +
            variantHtml +
            propertiesHtml +
            '<div class="defy-cart-item__bottom">' +
              '<div class="defy-cart-item__qty">' +
                '<button class="defy-cart-item__qty-btn" data-defy-cart-qty="' + item.key + '" data-delta="-1">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button class="defy-cart-item__qty-btn" data-defy-cart-qty="' + item.key + '" data-delta="1">+</button>' +
              '</div>' +
              '<span class="defy-cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="defy-cart-item__remove" data-defy-cart-remove="' + item.key + '" aria-label="Remove ' + escapeHtml(item.title) + '">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>';
    });

    body.innerHTML = html;
  }

  // ── Refresh cart: fetch /cart.js, update count + subtotal + items ────
  function refreshCart(callback) {
    fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      // Update count badge
      document.querySelectorAll('[data-defy-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      // Update subtotal
      var subtotalEl = document.getElementById('defy-cart-subtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      // Re-render items
      renderCartItems(cart);
      if (callback) callback(cart);
    });
  }

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden', 'false'); }
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  // Cart icon toggle — refresh then open
  document.querySelectorAll('[data-defy-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart(function () { openCart(); });
    });
  });

  // Close buttons
  document.querySelectorAll('[data-defy-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCart);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  // AJAX add to cart
  var form = document.getElementById('defy-product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

      var data = new FormData(form);

      // Add main product first, then personalisation fee if toggled, then refresh + open drawer
      var personaliseCheck = document.getElementById('defy-personalise-check');
      var personaliseProductId = form.dataset.personaliseId;
      var addPersonalise = personaliseCheck && personaliseCheck.checked && personaliseProductId;

      fetch(window.theme.cartAddUrl + '.js', {
        method: 'POST',
        body: data
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (addPersonalise) {
          return fetch(window.theme.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: personaliseProductId, quantity: 1 })
          });
        }
      })
      .then(function () {
        if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
        // Fetch fresh cart, re-render drawer, THEN open it
        refreshCart(function () { openCart(); });
      })
      .catch(function () {
        if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
      });
    });
  }

  // Detect if we're on the full cart page
  var isCartPage = document.querySelector('.defy-cart-page') !== null;

  // Qty update
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-defy-cart-qty]');
    if (!btn) return;
    var key   = btn.dataset.defyCartQty;
    var delta = parseInt(btn.dataset.delta, 10);
    var qtyEl = btn.parentElement.querySelector('span');
    var currentQty = parseInt(qtyEl ? qtyEl.textContent : 1, 10);
    var newQty = Math.max(0, currentQty + delta);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (isCartPage) {
        window.location.reload();
        return;
      }
      renderCartItems(cart);
      document.querySelectorAll('[data-defy-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      var subtotalEl = document.getElementById('defy-cart-subtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    });
  });

  // Remove item
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-defy-cart-remove]');
    if (!btn) return;
    var key = btn.dataset.defyCartRemove;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (isCartPage) {
        window.location.reload();
        return;
      }
      renderCartItems(cart);
      document.querySelectorAll('[data-defy-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      var subtotalEl = document.getElementById('defy-cart-subtotal');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    });
  });

  function formatMoney(cents) {
    // Use Shopify's formatMoney to respect the customer's active currency (GBP, EUR, etc.)
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    // Fallback to EUR if Shopify object not available
    return '\u20ac' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Init count on page load (no need to re-render items — Liquid already did it)
  fetch('/cart.js')
  .then(function (r) { return r.json(); })
  .then(function (cart) {
    document.querySelectorAll('[data-defy-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    var subtotalEl = document.getElementById('defy-cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  });

})();
